export const compareNumbers = (a: number, b: number) => a - b;

export const roundToStep = (step: number, value: number) => {
  const reminder = value % step;
  return value - reminder + (reminder < step / 2 ? 0 : step);
};
